var $name="htmlEntities",$path="configs/htmlEntities.js",$this={$name,$path,};module.exports = {
  space: ' ',
  nonBreakingSpace: '&nbsp;',
};
